import React, { useState, useEffect, lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import SideBar from './components/SideBar';
import Main from './pages/Main';
import { UserProvider } from './Contexts/UserContext';
import { NotificationProvider } from './components/Notification';
import LoadingSpinner from './components/LoadingSpinner';

// Lazy load all pages except Main (login page)
const Users = lazy(() => import('./pages/Users'));
const Exercise = lazy(() => import('./pages/Exercise'));
const Counsel = lazy(() => import('./pages/Counsel'));
const UserDetail = lazy(() => import('./pages/UserDetail'));
const UserReport = lazy(() => import('./pages/UserReport'));
const UserCounsel = lazy(() => import('./pages/UserCounsel'));
const UserPost = lazy(() => import('./pages/UserPost'));
const UserComment = lazy(() => import('./pages/UserComment'));
const UserCounselDetail = lazy(() => import('./pages/UserCounselDetail'));
const Survey = lazy(() => import('./pages/Survey'));
const Community = lazy(() => import('./pages/Community'));
const SurveyDetail = lazy(() => import('./pages/SurveyDetail'));
const CommunityRemoved = lazy(() => import('./pages/CommunityRemoved'));
const ExerciseDetail = lazy(() => import('./pages/ExerciseDetail'));
const BackupExercise = lazy(() => import('./pages/BackupExercise'));
const BackupExerciseDetail = lazy(() => import('./pages/BackupExerciseDetail'));
const BackupSurvey = lazy(() => import('./pages/BackupSurvey'));
const BackupSurveyDetail = lazy(() => import('./pages/BackupSurveyDetail'));
const UserAnalyze = lazy(() => import('./pages/UserAnalyze'));
const UserExerciseRate = lazy(() => import('./pages/UserExerciseRate'));
const CheckOutOptions = lazy(() => import('./pages/CheckOutOptions'));
const UserPremium = lazy(() => import('./pages/UserPremium'));
const Terms = lazy(() => import('./pages/Terms'));
const Notice = lazy(() => import('./pages/Notice'));

function App() {
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const sessionAuth = sessionStorage.getItem('authenticated');
    if (sessionAuth) {
      setAuthenticated(true);
    }
  }, []);

  // 인증 안할시 Main만 출력 (Main에서 로그인 화면)
  // 인증시, SideBar와 각 페이지들 출력 (인증 후 Main은 웰컴 페이지)
  return (
    <NotificationProvider>
      <UserProvider>
        <Router>
          <div className="flex h-screen overflow-hidden">
            {authenticated && <SideBar />}
            <main className="flex-1 min-w-0 p-8 overflow-y-auto bg-white">
              <Suspense fallback={<LoadingSpinner />}>
                <Routes>
                <Route path="/" element={<Main setAuthenticated={setAuthenticated} />} />
                {authenticated && (
                  <>
                    <Route path="/users" element={<Users />} />
                    <Route path="/userdetail" element={<UserDetail />} />
                    <Route path="/userreport" element={<UserReport />} />
                    <Route path="/userpremium" element={<UserPremium />} />
                    <Route path="/usercounsel" element={<UserCounsel />} />
                    <Route path="/usercounseldetail" element={<UserCounselDetail />} />
                    <Route path="/userexerciserate" element={<UserExerciseRate />} />
                    <Route path="/useranalyze" element={<UserAnalyze />} />
                    <Route path="/userpost" element={<UserPost />} />
                    <Route path="/usercomment" element={<UserComment />} />
                    <Route path="/counsel" element={<Counsel />} />
                    <Route path="/exercise" element={<Exercise />} />
                    <Route path="/exercisedetail" element={<ExerciseDetail />} />
                    <Route path="/survey" element={<Survey />} />
                    <Route path="/surveydetail" element={<SurveyDetail />} />
                    <Route path="/backup/exercise" element={<BackupExercise />} />
                    <Route path="/backup/exercisedetail" element={<BackupExerciseDetail />} />
                    <Route path="/backup/survey" element={<BackupSurvey />} />
                    <Route path="/backup/surveydetail" element={<BackupSurveyDetail />} />
                    <Route path="/community" element={<Community />} />
                    <Route path="/communityremoved" element={<CommunityRemoved />} />
                    <Route path="/checkoutoptions" element={<CheckOutOptions />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="/notice" element={<Notice />} />
                  </>
                )}
              </Routes>
            </Suspense>
          </main>
        </div>
      </Router>
    </UserProvider>
    </NotificationProvider>
  );
}

export default App;